import { SelectSubscriptionPage } from "./SelectSubscriptionPage";

export default SelectSubscriptionPage;
